import { createFileRoute } from '@tanstack/react-router';
import { ChangelogPage } from '@/features/changelog/ChangelogPage';

export const Route = createFileRoute('/_app/whats-new')({
  component: ChangelogPage,
});
